import { render, staticRenderFns } from "./BSlideshow.vue?vue&type=template&id=68a546b2&"
import script from "./BSlideshow.vue?vue&type=script&lang=js&"
export * from "./BSlideshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports